// Creates a column that cards can be dropped into.
// Maybe holds a compare function for its top most child and a card that is being
// dropped into it
// Responsible for organizing cards into a neat column

import React, { Component } from 'react';
import Card from './Card';
import Deck from './Deck';

import './Card-Structure.css';
import './Card-Top-Level.css';
import './IceColumn.css';

export default class IceColumn extends Component {
    constructor () {
        super ();

        this.state = {
            ice: 'ice'
        }

        this.createCardElement = this.createCardElement.bind (this);
    }

    createCardElement (data, index) {
        if (data === null) { return }
        if (!data.key) { data.key = Math.random ()*1000 }
        if (!data.position) { data.position = {x: 0, y: 0} }
        // if (!data.key || !data.position) {
        //     return (<div key={index}></div>)
        // }

        return (
            <Card
                key={index}
                id={data.id}
                name={data.name}
                img={data.img}
                zIndex={data.zIndex}
                isActive={data.isActive}
                position={data.position}
                isFaceDown={data.isFaceDown}
                isDiscarded={data.isDiscarded}
                isPlacedInColumn={data.isPlacedInColumn}
                isProtected={data.isProtected}
                type={data.type}
                index={index}
                diet={data.diet}
                symbol={data.symbol}
                iceDestroyed={this.props.iceDestroyed}
                facts={data.facts}
                trophicLevel={data.trophicLevel}
                needsIce={data.needsIce}
                validTargets={data.validTargets}
                footer={data.footer}
                blockerText={data.blockerText}
                validTargets={data.validTargets}
                isScared={data.isScared}

                onMouseDown={this.props.onMouseDownOnCard}
                protectedSpeciesName={this.props.protectedSpeciesName}
            />
        )
    }

    render () {
        let className = 'card-container top-level ';
        className += this.props.ice ? 'ice' : 'ice-melted';

        return (
            <div className="ice-column" id={this.props.id}>
                <div className={className}>
                    <section className="card-wrapper"></section>
                </div>
                <div className="column">
                    {this.props.children.map ( this.createCardElement )}
                </div>
            </div>
        )
    }
}
